<template>
  <div>
    <v-dialog v-model="updateRouteDialog" max-width="500px">
        <route-route-form
          :selectedRoute="currentRoute"
          v-on:close-route-dialog="updateRouteDialog = false"
          v-on:error="onUpdateRouteError"
          v-on:success="onUpdateRouteSuccess"
        />
      </v-dialog>
    <route-route-list 
      :batch="batchId" 
      :updatedRoute="currentRoute"
      v-on:update-route="showRouteUpdateDialog"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      updateRouteDialog: false,
      currentRoute: {},
    };
  },
  computed: {
    batchId() {

      return this.$route.params.idBatch;
    },
  },
  methods: {
    onUpdateRouteError(event) {
      this.updateRouteDialog = false;
      this.$emit('error', event);
    },
    onUpdateRouteSuccess(event) {
      this.updateRouteDialog = false;
      this.currentRoute = event;
      this.$emit('success', 'Datos del lote actualizados');
    },
    showRouteUpdateDialog(event) {
      this.currentRoute = event;
      this.updateRouteDialog = true;
    },
  },
};
</script>